import Product from "modules/product/types/Product";
import Workflow from "../types/Workflow";

export default (workflow: Workflow): Product[] =>
  (workflow.products || []).filter((product) => product.external);
